if (!customElements.get('stil-gallery')) {
  class StilGallery extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-stil-grid]');
      this.sentinel = this.querySelector('[data-stil-sentinel]');
      this.chips = [...this.querySelectorAll('[data-stil-chip]')];
      this.nextUrl = this.sentinel?.dataset.next || '';
      this.loading = false;
      this.activeTag = '';

      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => this.selectChip(chip));
      });

      const fromUrl = new URLSearchParams(window.location.search).get('etiket');
      if (fromUrl) {
        const match = this.chips.find(
          (chip) => !chip.dataset.all && this.sameTag(chip.dataset.tag, fromUrl)
        );
        if (match) this.selectChip(match, false);
      }

      if (this.sentinel && this.nextUrl) {
        this.sentinel.hidden = false;
        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) this.loadMore();
          },
          { rootMargin: '1000px 0px' }
        );
        this.observer.observe(this.sentinel);
      }

      this.applyFilter();
    }

    sameTag(a, b) {
      return String(a || '').trim().toLocaleLowerCase('tr') === String(b || '').trim().toLocaleLowerCase('tr');
    }

    selectChip(chip, updateUrl = true) {
      this.chips.forEach((item) => {
        const on = item === chip;
        item.classList.toggle('is-active', on);
        item.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.activeTag = chip.dataset.all ? '' : chip.dataset.tag || '';
      if (updateUrl) {
        const url = new URL(window.location.href);
        if (this.activeTag) url.searchParams.set('etiket', this.activeTag);
        else url.searchParams.delete('etiket');
        history.replaceState({}, '', url);
      }
      this.applyFilter();
      if (this.visibleCount() < 8) this.loadMore();
    }

    cardTags(card) {
      return (card.dataset.tags || '').split('|').filter(Boolean);
    }

    visibleCount() {
      if (!this.grid) return 0;
      return [...this.grid.querySelectorAll('[data-stil-card]')].filter((card) => !card.hidden).length;
    }

    applyFilter() {
      if (!this.grid) return;
      this.grid.querySelectorAll('[data-stil-card]').forEach((card) => {
        if (!this.activeTag) {
          card.hidden = false;
          return;
        }
        card.hidden = !this.cardTags(card).some((tag) => this.sameTag(tag, this.activeTag));
      });
    }

    async loadMore() {
      if (!this.nextUrl || this.loading) return;
      this.loading = true;
      let chain = false;
      try {
        const url = new URL(this.nextUrl, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const html = await fetch(url.toString()).then((response) => response.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const more = doc.querySelector('[data-stil-grid]');
        if (more) {
          [...more.children].forEach((node) => this.grid.appendChild(node));
        }
        const incoming = doc.querySelector('[data-stil-sentinel]');
        this.nextUrl = incoming?.dataset.next || '';
        if (this.sentinel) this.sentinel.dataset.next = this.nextUrl;
        this.applyFilter();
        if (!this.nextUrl && this.observer) this.observer.disconnect();
        chain = Boolean(this.activeTag && this.nextUrl && this.visibleCount() < 8);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
        if (chain) this.loadMore();
      }
    }
  }

  customElements.define('stil-gallery', class extends StilGallery {});
}
